// extracted by mini-css-extract-plugin
export default {"reg":"styles_reg__fchEg","body":"styles_body__N63ko","left":"styles_left__L4-b2"};